import CityPageTemplate from "../city-template/CityPageTemplate";
import { gorhamConfig } from "./data";

export default function GorhamPage() {
  return <CityPageTemplate config={gorhamConfig} />;
}